export default __webpack_public_path__ + "static/media/egranting-landing-bk.866d9fe4.jpeg";